var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"o-btn",class:[
    { 'o-btn--icon-r': _vm.iconPosition === 'right' },
    { 'o-btn--icon-l': _vm.iconPosition === 'left' },
    { 'o-btn--icon-c': _vm.iconPosition === 'center' }
  ],attrs:{"type":_vm.type}},[(_vm.icon && _vm.showPreloader)?_c('i',[_c('c-preloader',{attrs:{"color":'white'}})],1):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.icon && !_vm.showPreloader)?_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }